import React, { useState, useEffect } from "react";
import { collection, orderBy, query, limit, doc } from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import Leaderboard from "components/leaderboard";
import { useTranslation } from "react-i18next";
import { useLeague } from "context/leagueContext";
import { useRound } from "context/roundContext";
import PayoutList from "components/payoutList";

const PayoutChart = () => {
  const [userList, setUserList] = useState([]);
  const [roundInfo, setRoundInfo] = useState(undefined);

  const {
    state: { leagueInfo },
  } = useLeague();
  const {
    state: { currentRound },
  } = useRound();
  const { t } = useTranslation();
  const firestore = useFirestore();

  const roundInfoRef = doc(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/rounds/",
    currentRound.id
  );
  const { status: roundInfoStatus, data: roundInfoDoc } =
    useFirestoreDocData(roundInfoRef);
  useEffect(() => {
    if (roundInfoDoc) {
      setRoundInfo(roundInfoDoc);
    }
  }, [roundInfoDoc]);

  return (
    <>
      <div className="block uppercase tracking-wide text-xs mb-1 pl-2 text-textPrimary">
        {/* {t("tournament.leaderboard.top")} 5 */}
        {t("tournament.leaderboard.round")}
      </div>
      <div className="flex rounded-md bg-white  mb-4">
        <PayoutList
          list={roundInfo?.leaderboard}
          payout={roundInfo?.prizePool}
          isLoading={roundInfoStatus === "loading"}
          settled={currentRound?.settled}
          hasWinnings={leagueInfo?.gameRule == 4 ? false : true}
        />
      </div>
    </>
  );
};

export default PayoutChart;
